import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function Rd2sReducer(state = initialState.cdstatuss, action: any) {
  switch (action.type) {
    case types.SAVE_CDSTATUSS_SUCCESS:
      return action.cdstatuss;
    default:
      return state;
  }
}
